import { createContext, useContext, useState, useEffect } from 'react'
import { api } from '../services/api'
import { useAuth } from './AuthContext'

const StatsContext = createContext({})

export const useStats = () => {
  const context = useContext(StatsContext)
  if (!context) {
    throw new Error('useStats must be used within a StatsProvider')
  }
  return context
}

export const StatsProvider = ({ children }) => {
  const [userStats, setUserStats] = useState({
    monthlyPnL: 0,
    monthlyPnLPercent: 0,
    totalTrades: 0,
    winRate: 0
  })
  const [loading, setLoading] = useState(false)
  const { user } = useAuth()

  const fetchUserStats = async () => {
    try {
      if (!user) return
      
      setLoading(true)
      // Fetch analytics for current month
      const analyticsResponse = await api.analytics.getOverview({ period: '30d' })
      const metrics = analyticsResponse.data.metrics || {}
      
      setUserStats({
        monthlyPnL: metrics.totalPnL || 0,
        monthlyPnLPercent: ((metrics.totalPnL || 0) / 10000 * 100), // Rough calculation
        totalTrades: metrics.totalTrades || 0,
        winRate: metrics.winRate || 0
      })
    } catch (error) {
      console.error('Error fetching user stats:', error)
      // Keep default values on error
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUserStats()
  }, [user])

  const refreshStats = () => {
    fetchUserStats()
  }

  const value = {
    userStats,
    loading,
    refreshStats
  }

  return (
    <StatsContext.Provider value={value}>
      {children}
    </StatsContext.Provider>
  )
}